(function() {
  'use strict';
  
  angular
    .module('app')
    .config(config);
    
  config.$inject = [
    '$anchorScrollProvider',
    '$logProvider',
    '$urlRouterProvider',
    '$locationProvider',
    'localStorageServiceProvider'
  ];
  
  function config(
      $anchorScrollProvider,
      $logProvider,
      $urlRouterProvider,
      $locationProvider,
      localStorageServiceProvider
    ) {
    
    // Set default route
    $urlRouterProvider.otherwise("/");

    // Remove ! from the route
    $locationProvider.hashPrefix('');

    // Disable auto scrolling based on location.hash
    $anchorScrollProvider.disableAutoScrolling();
    
    // Turn off debug logging
    $logProvider.debugEnabled(false);
    
    // Configure prefix for localStorage
    localStorageServiceProvider
      .setPrefix('mars');
  }

  
})();